<script>
import { componentStore } from "@common/componentStore/componentStore";
import { controlEditorSettings } from "@common/control/controlStore";

let editorSettings = {
    buttonPanelSettingsPanel: {
        type: 'panel',
        label: 'Button Panel Settings',
        id: 'buttonPanelSettingsPanel',
        fields: [
            'listDirection',
            'listAlignment',
            'controls'
        ]
    },
    listDirection: {
        type: 'dropdown',
        label: 'Button List Direction',
        id: 'listDirection',
        items: [
            'vertical',
            'horizontal'
        ],
        // eslint-disable-next-line max-len
        helpText: 'Buttons can be listed vertically or horizontally.  Vertical: puts a single button on every line.  Horizontal: lists the buttons across the width of the page following the natural flow of wording.  Vetical is the same as display: block in css, horizontal is the same as display: inline-block in css'
    },
    listAlignment: {
        type: 'dropdown',
        label: 'Alignment',
        id: 'listAlignment',
        items: [
            'left',
            'right',
            'center',
        ],
        logic: [
            {
                record: 'self',
                prop: 'display',
                valueType: 'criteria',
                criteria: 'this.controls.listDirection.value === "horizontal"'
            }
        ],
        default: 'left',
        helpText: 'Align the buttons left right or center of the control panel.'
    },
};
editorSettings.controls = library.cloneObj(controlEditorSettings.controls);
editorSettings.controls.itemConfig.keys.type.itemsFilter = '["button", "boolean"].indexOf(this.item.value) != -1';

let buttonPanelConfig = {
    cId: "buttonPanel",
    cType: "buttonPanel",
    cTitle: "Button Panel",
    cTemplate: `<div v-if="config" class="control-panel" :class="configClasses" :style="componentStyles">
        <div v-for="iControl in config.controls" class="cp-control-container">
            <control :name="iControl.name"></control>
        </div>
    </div>`,
    controls: []
};

let buttonPanelCmp = {
    name: 'buttonPanel',
    editorSettings: editorSettings,
    dataTestIds: [],
    props: {
        recordSource: {
            type: Array,
            default: false
        }
    },
    data() {
        return {};
    },
    computed: {
        parentSettings() {
            let parentSettings = false;
            if (this.$parent && this.$parent.cType === 'layoutContainer' && this.$parent.childComponentSettings) {
                parentSettings = this.$parent.childComponentSettings;
            }
            if (parentSettings) {
                let psKeys = Object.keys(parentSettings);
                psKeys.forEach((key) => {
                    if (typeof this.config[key] === 'object' && this.config[key].value !== null && this.config[key].value !== '') {
                        parentSettings[key] = this.config[key].value;
                    }
                });
            } else parentSettings = {};
            return parentSettings;
        },
        directionClass() {
            if (!this.config.listDirection) return "";
            return 'cp-' + this.config.listDirection;
        },
        alignmentClass() {
            if (!this.config.listAlignment) return "";
            return 'cp-' + this.config.listAlignment;
        },
        configClasses() {
            let classString = '';
            if (this.directionClass) classString += this.directionClass;
            if (this.alignmentClass) classString += ' ' + this.alignmentClass;
            return classString;
        }
    }
};

componentStore.initComponent(buttonPanelCmp, buttonPanelConfig, '@common/buttonPanel.vue');
export { buttonPanelConfig, buttonPanelCmp };
export default buttonPanelCmp;
</script>

<style scoped>
    .control-panel {
        padding: 10px;
    }
    .cp-horizontal .cp-control-container {
        margin-right: 15px;
    }
    .control-panel.cp-horizontal {
        display: flex;
    }
    .control-panel.cp-right {
        flex-direction: row-reverse;
    }
    .control-panel.cp-center {
        justify-content: center;
    }
</style>
